export const dashboardApiEndpoints = {
  getStats: `/dashboard`,
};
